import React from "react";

export default function Logo() {
    return (
        <div className="flex h-10 w-10 -rotate-6 items-center justify-center rounded-lg bg-blue-600 dark:bg-blue-700">
            <div className="flex h-10 w-10 rotate-12 items-center justify-center rounded-lg bg-blue-500 dark:bg-blue-600">
                <div className="flex h-10 w-10 rotate-6 items-center justify-center rounded-lg bg-blue-400 dark:bg-blue-500">
                    <div className="-rotate-[12deg] font-bold text-white">R</div>
                </div>
            </div>
        </div>
    );
}
